module.exports = __webpack_public_path__ + "05_mole.99f5c9bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer2/05_mole.png
// module id = KtsH
// module chunks = 0